"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("settings-ui-sdk/PortalSettings/actions");

var _AccountDefaultsActions = require("../actions/AccountDefaultsActions");

var _Modals = _interopRequireDefault(require("../constants/Modals"));

var _actions2 = require("settings-ui-sdk/SingleSignOn/actions");

var _PortalSettingsKeys = _interopRequireDefault(require("settings-ui-sdk/constants/PortalSettingsKeys"));

var _UsageTracker = _interopRequireDefault(require("settings-ui-app/utils/UsageTracker"));

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  tracking: {
    interaction: null
  }
});
var INTERACTION_PATH = ['tracking', 'interaction'];

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_actions.SavePortalSettingActionTypes.SUCCESS, _actions.StageAndSavePortalSettingActionTypes.SUCCESS), function (state, action) {
  var _action$payload$data = action.payload.data,
      key = _action$payload$data.key,
      value = _action$payload$data.value; // eslint-disable-next-line default-case

  switch (key) {
    case _PortalSettingsKeys.default.GDPR_COMPLIANCE_ENABLED:
    case _PortalSettingsKeys.default.GDPR_ENFORCEMENT_ENABLED:
    case _PortalSettingsKeys.default.GDPR_UNSUBSCRIBE_LINK_ENABLED:
      _UsageTracker.default.track('changeGDPRSetting', {
        action: key,
        value: value == 'true'
      });

      break;
  }

  return state;
}), (0, _defineProperty2.default)(_handleActions, _AccountDefaultsActions.AccountDefaultActionTypes.OPEN_MODAL, function (state, action) {
  var modalName = action.payload; // eslint-disable-next-line default-case

  switch (modalName) {
    case _Modals.default.EDIT_SSO:
    case _Modals.default.REQUIRE_SSO:
    case _Modals.default.UNREQUIRE_SSO:
    case _Modals.default.EDIT_SSO_EXEMPT_USERS:
      _UsageTracker.default.track('editSSOConfig', {
        action: action.type,
        modal: modalName
      });

  }

  return state.setIn(INTERACTION_PATH, modalName);
}), (0, _defineProperty2.default)(_handleActions, _AccountDefaultsActions.AccountDefaultActionTypes.CLOSE_MODAL, function (state, action) {
  var modalName = state.getIn(INTERACTION_PATH); // eslint-disable-next-line default-case

  switch (modalName) {
    case _Modals.default.EDIT_SSO:
    case _Modals.default.REQUIRE_SSO:
    case _Modals.default.UNREQUIRE_SSO:
    case _Modals.default.EDIT_SSO_EXEMPT_USERS:
      _UsageTracker.default.track('editSSOConfig', {
        action: action.type,
        modal: modalName
      });

  }

  return state.deleteIn(INTERACTION_PATH);
}), (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_actions2.ConfirmSamlSettingsActionTypes.SUCCESS, _actions2.DeleteSamlSettingsActionTypes.SUCCESS, _actions2.SaveSamlSettingsActionTypes.SUCCESS, _actions2.UpdateSamlRequirementActionTypes.SUCCESS, _actions2.SaveExemptUsersActionTypes.SUCCESS), function (state, action) {
  _UsageTracker.default.track('editSSOConfig', {
    action: action.type
  });

  return state;
}), (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_actions2.ConfirmSamlSettingsActionTypes.FAILURE, _actions2.SaveSamlSettingsActionTypes.FAILURE), function (state, action) {
  var responseJSON = action.payload.error.responseJSON;

  _UsageTracker.default.track('editSSOConfig', {
    action: action.type,
    error: responseJSON.errors ? responseJSON.errors[0] : responseJSON.message
  });

  return state;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;